export default "__VITE_ASSET__DotQAN4w__"